// App.js
//import './App.css';
import SignIn from './components/auth/SignIn';
import Login from './components/login-signup/login.jsx';
import SignUp from './components/auth/SignUp';
import SignUp2 from './components/login-signup/signup.jsx';
import AccountEngine from './components/AccountEngine2';
import Politica from './components/Politica';
import Account from './components/Account';
import LandingPage from './components/landingpage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthContextProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { SidebarProvider } from './components/layout/context/SidebarContext';
import ProtectedRoute from './components/ProtectedRoute';
import Manuel from './components/Manual';
import PasswordReset from './components/auth/reset';
import ProtectedLayout from './components/layout/ProtectedLayout';
import NewComponent from './components/layout/components/NewComponent';
import Manuellayout from './components/Manual2';
import Header from './components/Location';
import SavedQuestions from './components/saved_questions';
import TemisLandingPage from './components/landing page/landingPage.jsx'
import NotFound from './components/NotFound.jsx';
import BdgCurso from './components/bdg/BdgCurso.jsx';
import './styles/styles.css';


function App() {
  return (
    <Router>      
        <AuthContextProvider>
          {/* <SidebarProvider> */}
          <ThemeProvider> 
            <Routes>
              <Route path="/signin" element={<SignIn />} />
              <Route path="/login" element={<Login />} />
              <Route path="/reset-password" element={<PasswordReset />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/signup2" element={<SignUp2 />} />
              <Route path="/" element={<TemisLandingPage />} />
              <Route path="/manual" element={<Manuel />} />
              <Route path="/politica" element={<Politica />} />
              <Route path="/bdg" element={<BdgCurso />} />
              <Route path="/cuenta" element={<ProtectedRoute><Account /></ProtectedRoute>} /> {/**este ya no */}
              <Route path="/account" element={<ProtectedRoute><ProtectedLayout /></ProtectedRoute>}>
                <Route index element={<AccountEngine />} />
                <Route path="Temis" element={<AccountEngine />} />
                <Route path="politica" element={<Politica />} />
                <Route path="manual" element={<Manuellayout />} />
                <Route path="new" element={<NewComponent />} />
                <Route path="guardado" element={<SavedQuestions />} />
                {/* Add more nested routes here if needed */}
              </Route>
               {/* Ruta 404 - debe ir al final */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          {/* <SidebarProvider> */}
          </ThemeProvider>
        </AuthContextProvider>

    </Router>
  );
}

export default App;
